/**
 * Cost-Overview Service — FinOps #867 T6 (viewer read).
 *
 * Fetches the per-cost-center cost overview (Ist + Schätzung + budget) for a
 * given month from GET /api/cost-overview. Reuses the shared apiClient so
 * 401/403/5xx flow through the existing global error interceptor.
 */

import apiClient from './api';
import { ApiResponse } from './types';

export interface CostOverviewRow {
  code: string;
  displayName: string;
  type: string;
  budgetMonthlyEur: number;
  istEur: number;
  schaetzungEur: number;
}

export interface CostOverview {
  month: string; // YYYY-MM
  generatedAt: string;
  costCenters: CostOverviewRow[];
}

export const costOverviewApi = {
  /**
   * Fetch the cost overview. Pass `month` (YYYY-MM) to scope to a month;
   * omit for the current month (the backend defaults it).
   */
  async get(month?: string): Promise<CostOverview> {
    const response = await apiClient.get<ApiResponse<CostOverview>>('/cost-overview', {
      params: month ? { month } : undefined,
    });
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error || 'Failed to fetch cost overview');
    }
    return response.data.data;
  },
};
